/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum StockReceiptStatus {
  Posted = 'POSTED',
  Canceled = 'CANCELED'
}
